<!--Right Side Column Info widgets-->
<template>
  <v-card flat class="rsidecard mb-3 mr-3 pb-3" max-width="400" width="100%" min-width="250" > 
    <v-card-title class="mb-1">
      <h5 class="text-h5" >{{title}}</h5>
    </v-card-title>
        
    <v-card-text class="pb-2">
      <p class="infowdgtxt darkgrey-text" v-html="content"></p>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name:'hklii-infowidget',
    props:[
      'title',
      'content'
    ],
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  h5 {
    line-break: auto;  /*for CKJ*/
    word-break: normal
  }

  ::v-deep p {
    font-size: 10pt;
    line-height: 12.5pt;
    line-break: auto;  /*for CKJ*/
    word-break: normal;
    margin-bottom: 8px;
  }

  .infowdgtxt ::v-deep a {
    @include link-no-underline;
  }

</style>